import { Component, OnInit, Input, inject, input, output } from '@angular/core';
import { State, AddressList } from 'src/app/modules/user-profile/models/contact-oeds-person.model';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';


@Component({
    selector: 'app-contact-verification-address-form',
    templateUrl: './contact-verification-address-form.component.html',
    styleUrls: ['./contact-verification-address-form.component.css'],
    imports: [FormsModule, ReactiveFormsModule]
})
export class ContactVerificationAddressFormComponent implements OnInit {
  cservice = inject(ContactVerificationService);

  addressform: UntypedFormGroup;
  exaddress: AddressList;
  readonly close = output<any>();
  readonly doCancel = output<any>();
  readonly doUpdate = output<any>();
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() selectedaddress: AddressList;
  readonly stateslist = input<State[]>([]);

  ngOnInit() {
    this.exaddress = Object.assign({}, this.selectedaddress);
    const numberPattern = '^[0-9]*$';
    this.addressform = new UntypedFormGroup({
      address: new UntypedFormControl({ value: '' }, Validators.compose([Validators.required])),
      city: new UntypedFormControl({ value: '' }, Validators.compose([Validators.required])),
      state: new UntypedFormControl({ value: '' }, Validators.compose([Validators.required])),
      zipcode: new UntypedFormControl({ value: '' }, Validators.compose([Validators.required, Validators.pattern(numberPattern)])),
      zipCode4: new UntypedFormControl({ value: '' }, Validators.compose([Validators.pattern(numberPattern)]))
    });
  }
  onStateSelected(event) {
    const optValue = event.target.value;
    const optText=event.target.options[event.target.options.selectedIndex].text
    this.selectedaddress.stateKey = optValue;
    this.selectedaddress.state = optText;
  }
  cancel() {
    var exaddresslist = this.cservice.oedsPersonCopy.addressList;
    Object.assign(this.cservice.filterAddressByType(this.selectedaddress.oedsAddressType, this.selectedaddress.oedsLocationType,exaddresslist)[0], this.exaddress);
    this.doCancel.emit(null);
  }
  update() {
    if (this.selectedaddress.oedsAddressKey == 0)
      this.selectedaddress.actionType = "Inserted";
    else
      this.selectedaddress.actionType = "Updated";
    this.selectedaddress.zipCode4 = this.selectedaddress.zipCode4===null? "" : this.selectedaddress.zipCode4;
    this.doCancel.emit(null);
  }
}
